import type { SxStyle } from '@aibees/shared/theme';
import type { AccountPopoverCreditPlanDetailVariant } from './types';

export const root = (
  variant: AccountPopoverCreditPlanDetailVariant
): SxStyle => ({
  width: variant === 'credit-balance' ? 'auto' : '100%',
});

export const card = (
  variant: AccountPopoverCreditPlanDetailVariant
): SxStyle => ({
  width: variant === 'credit-balance' ? 'auto' : '100%',
  textAlign:
    variant === 'popover'
      ? 'center'
      : variant === 'credit-balance'
      ? 'right'
      : 'left',
  borderRadius: (p) => p.spacing(1),
  padding: (p) =>
    variant === 'popover'
      ? p.spacing(0.75, 1)
      : variant === 'enrichment'
      ? p.spacing(0.75, 0)
      : 0,
  backgroundColor: (p) =>
    variant === 'popover' ? p.palette.grey[200] : 'transparent',
});
